import { BaseGrid } from './BaseGrid'
import { OnDemandList } from './OnDemandList'
import { Selector } from './Selector' // this extends Selection

export const Grid = Selector(OnDemandList(BaseGrid))